<template>
  <div>
    <table class="w-full border-collapse">
      <thead>
        <tr class="border-b border-gray-02">
          <th class="text-left py-2 text-sm font-medium text-gray-07 pl-6">
            Prefixo
          </th>
          <th class="text-left py-2 text-sm font-medium text-gray-07">
            Significado
          </th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr class="border-b border-gray-02">
          <td class="py-2 text-gray-07 pl-6">
            DA
          </td>
          <td class="py-2 text-gray-07">
            Dados
          </td>
        </tr>
        <tr class="border-b border-gray-02">
          <td class="py-2 text-gray-07 pl-6">
            MQ
          </td>
          <td class="py-2 text-gray-07">
            Manual da Qualidade
          </td>
        </tr>
        <tr class="border-b border-gray-02">
          <td class="py-2 text-gray-07 pl-6">
            PR
          </td>
          <td class="py-2 text-gray-07">
            Procedimento
          </td>
        </tr>
        <tr class="border-b border-gray-02">
          <td class="py-2 text-gray-07 pl-6">
            IT
          </td>
          <td class="py-2 text-gray-07">
            Instrução de Trabalho
          </td>
        </tr>
      </tbody>
    </table>
    <p class="text-sm text-gray-07 mt-5">
      Use um desses prefixos para enviar os documentos.
    </p>
  </div>
</template>
